(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dian-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const landscape = window.matchMedia('(min-aspect-ratio: 1/1)');

    const setSource = (hero) => {
      const video = hero.querySelector('video.dian-hero__video');
      if (!video) return;
      const src = landscape.matches ? video.dataset.srcLandscape : video.dataset.srcPortrait;
      if (video.getAttribute('src') !== src) {
        video.src = src;
        video.load();
      }
      if (hero.dataset.paused !== 'true') video.play().catch(() => {});
    };

    const setPaused = (hero, paused) => {
      const video = hero.querySelector('video.dian-hero__video');
      const button = hero.querySelector('[data-dian-hero-toggle]');
      hero.dataset.paused = String(paused);
      if (video) paused ? video.pause() : video.play().catch(() => {});
      if (button) {
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
      }
    };

    const init = () => {
      document.querySelectorAll('[data-dian-hero]').forEach((hero) => {
        if (reduceMotion.matches) hero.dataset.paused = 'true';
        setSource(hero);
      });
    };

    landscape.addEventListener('change', () => document.querySelectorAll('[data-dian-hero]').forEach(setSource));
    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-dian-hero-toggle]') : null;
      if (!button) return;
      const hero = button.closest('[data-dian-hero]');
      setPaused(hero, hero.dataset.paused !== 'true');
    });
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dian-footer"] && !Shopify.designMode) return;
  try {
    
  // Columns are open on desktop and collapsible on phones.
  (() => {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const sync = () => {
      document.querySelectorAll('.dian-footer__column').forEach((d) => {
        if (desktop.matches) d.setAttribute('open', '');
        else d.removeAttribute('open');
      });
    };
    desktop.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dian-password"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const landscape = window.matchMedia('(min-aspect-ratio: 1/1)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const play = (video) => {
      if (reduceMotion.matches) {
        video.pause();
        return;
      }
      video.muted = true;
      video.play().catch(() => {});
    };
    const setSource = () => {
      document.querySelectorAll('[data-dian-pw] video.dian-pw__video').forEach((video) => {
        if (reduceMotion.matches) video.removeAttribute('autoplay');
        const src = landscape.matches ? video.dataset.srcLandscape : video.dataset.srcPortrait;
        if (video.getAttribute('src') !== src) {
          // Start as soon as the new source can play (an immediate play() gets cut off by load()).
          video.addEventListener('canplay', () => play(video), { once: true });
          video.src = src;
          video.load();
        } else {
          play(video);
        }
      });
    };
    landscape.addEventListener('change', setSource);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setSource);
    else setSource();

    // Glass effects: the video is drawn through a shader on a canvas.
    //   textured: pebbled glass.  rain: steamed-up window in the rain, logo wiped clear.
    // Without WebGL (or if the video can't be read) the page falls back to a CSS blur.
    const VS = 'attribute vec2 p;varying vec2 uv;void main(){uv=p*0.5+0.5;uv.y=1.0-uv.y;gl_Position=vec4(p,0.,1.);}';
    const COMMON = `precision highp float;varying vec2 uv;uniform sampler2D t;uniform vec2 res;uniform vec2 vres;
      float h11(float n){return fract(sin(n*12.9898)*43758.5453);}
      float h21(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
      vec2 h22(vec2 p){return fract(sin(vec2(dot(p,vec2(127.1,311.7)),dot(p,vec2(269.5,183.3))))*43758.5453);}
      vec2 cover(vec2 q){float ca=res.x/res.y,va=vres.x/vres.y;vec2 s=ca>va?vec2(1.,va/ca):vec2(ca/va,1.);return (q-0.5)*s+0.5;}`;

    const TEXTURED_FS = COMMON + `uniform float cell;uniform float refr;uniform float blur;uniform float milk;
      uniform vec4 calm;uniform float feather;
      float vn(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*f*(f*(f*6.-15.)+10.);
        return mix(mix(h21(i),h21(i+vec2(1,0)),u.x),mix(h21(i+vec2(0,1)),h21(i+vec2(1,1)),u.x),u.y);}
      float pebble(vec2 p){vec2 i=floor(p),f=fract(p);float d=8.;
        for(int y=-1;y<=1;y++)for(int x=-1;x<=1;x++){vec2 g=vec2(float(x),float(y));vec2 r=g+0.1+0.8*h22(i+g)-f;d=min(d,dot(r,r));}
        return 1.-smoothstep(0.,0.6,d);}
      float height(vec2 p){vec2 w=vec2(vn(p*0.45),vn(p*0.45+5.2))*1.6;return pebble(p*vec2(1.,1.35)+w)*0.6+vn(p*1.3+w)*0.4;}
      void main(){vec2 px=uv*res;
        // calm zone behind the text: smooth, darker, more blurred glass that fades into the texture
        vec2 cc=calm.xy+calm.zw*0.5;vec2 hs=calm.zw*0.5+vec2(feather);
        float cq=length((px-cc)/max(hs,vec2(1.)));float cm=calm.z>0.?(1.-smoothstep(0.5,1.1,cq)):0.;
        vec2 g=px/cell;float e=0.12;float hc=height(g);
        vec2 n=vec2(height(g+vec2(e,0))-hc,height(g+vec2(0,e))-hc)/e*(1.-0.7*cm);
        vec2 off=n*refr/res;vec3 c=vec3(0.);float b2=blur*(1.+cm*0.8);
        for(int i=0;i<16;i++){float a=float(i)*2.39996;float r=sqrt((float(i)+0.5)/16.);
          c+=texture2D(t,cover(uv+off+vec2(cos(a),sin(a))*r*b2/res)).rgb;}
        c/=16.;vec3 N=normalize(vec3(-n*0.6,1.));vec3 L=normalize(vec3(-0.45,-0.55,0.85));
        float s=pow(max(dot(N,normalize(L+vec3(0,0,1))),0.),60.)*0.5*(1.-0.85*cm);float shade=(dot(N,L)-0.85)*0.3;
        c=pow(c,vec3(0.8))*1.2;c=c*(1.+shade)+s;c=mix(c,vec3(0.97,0.98,0.99),milk*(1.-cm));
        c=mix(c,c*0.55,cm);gl_FragColor=vec4(c,1.);}`;

    const RAIN_FS = COMMON + `uniform sampler2D m;uniform vec4 lr;uniform float time;uniform float dpr;uniform float fog;
      uniform float blur;uniform float amount;uniform vec3 drips[9];
      float vn(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);
        return mix(mix(h21(i),h21(i+vec2(1,0)),u.x),mix(h21(i+vec2(0,1)),h21(i+vec2(1,1)),u.x),u.y);}
      vec3 sharp(vec2 px){return texture2D(t,cover(px/res)).rgb;}
      vec3 fogged(vec2 px){vec3 c=vec3(0.);for(int i=0;i<14;i++){float a=float(i)*2.39996;float r=sqrt((float(i)+0.5)/14.);
        c+=sharp(px+vec2(cos(a),sin(a))*r*blur);}return c/14.;}
      vec3 drops(vec2 p,float cell,float dens,float seed){vec2 g=p/cell;vec2 id=floor(g);vec2 f=fract(g)*cell;vec3 best=vec3(0.);
        for(int y=-1;y<=1;y++)for(int x=-1;x<=1;x++){vec2 cid=id+vec2(float(x),float(y));if(h21(cid+seed)>dens)continue;
          vec2 c=(vec2(float(x),float(y))+0.2+0.6*h22(cid+seed*1.7))*cell;float rad=mix(0.08,0.4,pow(h21(cid*1.3+seed),3.))*cell;
          vec2 d=f-c;float mk=smoothstep(rad,rad*0.7,length(d*vec2(1.,0.88)));if(mk>best.z)best=vec3(d/rad,mk);}return best;}
      float logoA(vec2 px){vec2 q=(px-lr.xy)/lr.zw;if(q.x<0.||q.y<0.||q.x>1.||q.y>1.)return 0.;float a=texture2D(m,q).a;
        float o=1.8*dpr;a=max(a,texture2D(m,q+vec2(o,0)/lr.zw).a);a=max(a,texture2D(m,q-vec2(o,0)/lr.zw).a);
        a=max(a,texture2D(m,q+vec2(0,o)/lr.zw).a);a=max(a,texture2D(m,q-vec2(0,o)/lr.zw).a);return a;}
      void main(){vec2 px=uv*res;
        float la=logoA(px);float logo=smoothstep(0.3,0.6,la+(vn(px/(3.*dpr))-0.5)*0.35);
        float drip=0.;
        for(int i=0;i<9;i++){vec3 dr=drips[i];if(dr.z<0.5)continue;float fi=float(i);
          float x=lr.x+dr.x*lr.z;float top=lr.y+dr.y*lr.w;
          float len=mix(50.,220.,h11(fi*9.1))*dpr*clamp(fract(time*0.045+h11(fi*4.4))*1.5,0.,1.);
          float prog=clamp((px.y-top)/max(len,1.),0.,1.);float w=mix(1.6,3.2,h11(fi*5.3))*dpr*(1.-prog*0.5);
          float wob=sin(px.y*0.05/dpr+fi)*1.2*dpr;
          drip=max(drip,step(top,px.y)*step(px.y,top+len)*smoothstep(w,w*0.35,abs(px.x-x-wob)));
          drip=max(drip,smoothstep(w*2.,w*1.3,length((px-vec2(x+wob,top+len))*vec2(1.,0.8)))*step(3.*dpr,len));}
        float colW=46.*dpr;float cx=floor(px.x/colW);float trail=0.;vec3 run=vec3(0.);
        for(int k=-1;k<=1;k++){float col=cx+float(k);if(h11(col*1.31+7.)>amount)continue;
          float speed=mix(60.,170.,h11(col*7.7))*dpr;float period=(res.y+300.*dpr)/speed+mix(1.,6.,h11(col*3.3));
          float tt=mod(time+h11(col*5.1)*period,period);float y=tt*speed-150.*dpr;
          float xc=(col+0.5)*colW+(h11(col*2.2)-0.5)*colW*0.5;float xy=xc+sin(y*0.025/dpr+col)*5.*dpr;
          float rad=mix(4.5,7.5,h11(col*9.9))*dpr;vec2 d=px-vec2(xy,y);
          float mk=smoothstep(rad,rad*0.7,length(d*vec2(1.,0.72)));if(mk>run.z)run=vec3(d/rad,mk);
          float above=y-px.y;float xp=xc+sin(px.y*0.025/dpr+col)*5.*dpr;float fade=1.-clamp(above/(420.*dpr),0.,1.);
          float tw=rad*0.55*fade;trail=max(trail,step(0.,above)*smoothstep(tw,tw*0.3,abs(px.x-xp))*fade);}
        float clearA=max(logo,max(trail*0.8,drip*0.9));
        vec3 fogC=mix(fogged(px)*1.1,vec3(0.88,0.85,0.8),fog);
        vec3 col=mix(fogC,sharp(px),clearA);
        vec3 d1=drops(px,16.*dpr,0.32,1.);vec3 d2=drops(px+vec2(5.),6.*dpr,0.22*(1.-trail)+0.08,7.);
        vec3 dd=d1.z>d2.z?d1:d2;if(run.z>dd.z)dd=run;
        if(dd.z>0.){vec2 n=dd.xy;float r=length(n);vec3 refr=mix(sharp(px-n*10.*dpr),fogC,0.45)*1.12;
          refr=mix(refr,refr*0.85,smoothstep(0.7,1.,r));vec3 N=normalize(vec3(-n,1.1));
          refr+=pow(max(dot(N,normalize(vec3(-0.35,-0.6,1.))),0.),28.)*0.9+smoothstep(0.2,0.9,n.y)*0.12;
          col=mix(col,refr,dd.z*(1.-logo));}
        gl_FragColor=vec4(col,1.);}`;

    const setupGL = (canvas, fragment) => {
      const gl = canvas.getContext('webgl', { antialias: false, premultipliedAlpha: false });
      if (!gl) return null;
      const compile = (type, src) => {
        const shader = gl.createShader(type);
        gl.shaderSource(shader, src);
        gl.compileShader(shader);
        return gl.getShaderParameter(shader, gl.COMPILE_STATUS) ? shader : null;
      };
      const vs = compile(gl.VERTEX_SHADER, VS);
      const fs = compile(gl.FRAGMENT_SHADER, fragment);
      if (!vs || !fs) return null;
      const program = gl.createProgram();
      gl.attachShader(program, vs);
      gl.attachShader(program, fs);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;
      gl.useProgram(program);
      gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      const loc = gl.getAttribLocation(program, 'p');
      gl.enableVertexAttribArray(loc);
      gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      const texture = (unit) => {
        const tex = gl.createTexture();
        gl.activeTexture(gl.TEXTURE0 + unit);
        gl.bindTexture(gl.TEXTURE_2D, tex);
        [gl.TEXTURE_WRAP_S, gl.TEXTURE_WRAP_T].forEach((k) => gl.texParameteri(gl.TEXTURE_2D, k, gl.CLAMP_TO_EDGE));
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        return tex;
      };
      const u = (name) => gl.getUniformLocation(program, name);
      return { gl, texture, u };
    };

    // Where drips start: the lowest ink of the logo at nine points along its width.
    const dripPoints = (img) => {
      const c = document.createElement('canvas');
      c.width = 200;
      c.height = Math.max(1, Math.round((200 * img.naturalHeight) / img.naturalWidth));
      const ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, c.width, c.height);
      const data = ctx.getImageData(0, 0, c.width, c.height).data;
      const points = [];
      for (let i = 0; i < 9; i += 1) {
        const x = Math.min(c.width - 1, Math.round((0.06 + (0.88 * i) / 8) * (c.width - 1)));
        let found = null;
        for (let y = c.height - 1; y >= 0; y -= 1) {
          if (data[(y * c.width + x) * 4 + 3] > 128) {
            found = [x / (c.width - 1), y / (c.height - 1), 1];
            break;
          }
        }
        points.push(...(found || [0, 0, 0]));
      }
      return new Float32Array(points);
    };

    const startGlass = async (root) => {
      const canvas = root.querySelector('.dian-pw__canvas');
      const video = root.querySelector('video.dian-pw__video');
      if (!canvas || !video || canvas.dataset.ready) return;
      canvas.dataset.ready = 'true';
      const isRain = root.classList.contains('dian-pw--rain');
      const fail = () => root.classList.add('dian-pw--no-gl');
      const ctx = setupGL(canvas, isRain ? RAIN_FS : TEXTURED_FS);
      if (!ctx) return fail();
      const { gl, texture, u } = ctx;
      const videoTex = texture(0);
      gl.uniform1i(u('t'), 0);

      let logoImg = null;
      const logoPlace = root.querySelector('.dian-pw__logo-img');
      if (isRain) {
        gl.uniform1i(u('m'), 1);
        texture(1);
        if (root.dataset.rainLogo) {
          try {
            logoImg = new Image();
            logoImg.src = root.dataset.rainLogo;
            await logoImg.decode();
            gl.activeTexture(gl.TEXTURE1);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, logoImg);
            gl.uniform3fv(u('drips[0]'), dripPoints(logoImg));
          } catch (error) {
            logoImg = null;
          }
        }
        const amount = { light: 0.3, medium: 0.45, heavy: 0.62 }[root.dataset.rainAmount] || 0.45;
        gl.uniform1f(u('amount'), amount);
        const fog = parseFloat(root.dataset.rainFog);
        gl.uniform1f(u('fog'), Number.isFinite(fog) ? fog : 0.58);
      } else {
        const light = parseFloat(root.dataset.glassLight);
        gl.uniform1f(u('milk'), Number.isFinite(light) ? light : 0.18);
      }
      const size = parseFloat(root.dataset.glassSize) || 15;
      const blur = parseFloat(root.dataset.glassBlur) || 34;
      const start = performance.now();

      const draw = () => {
        if (video.readyState < 2 || !video.videoWidth) return true;
        const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        const w = Math.round(canvas.clientWidth * dpr);
        const h = Math.round(canvas.clientHeight * dpr);
        if (canvas.width !== w || canvas.height !== h) {
          canvas.width = w;
          canvas.height = h;
        }
        gl.viewport(0, 0, w, h);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, videoTex);
        try {
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, video);
        } catch (error) {
          // e.g. a video from another site without permission to read its pixels
          fail();
          return false;
        }
        gl.uniform2f(u('res'), w, h);
        gl.uniform2f(u('vres'), video.videoWidth, video.videoHeight);
        if (isRain) {
          const box = canvas.getBoundingClientRect();
          const place = logoImg && logoPlace ? logoPlace.getBoundingClientRect() : null;
          if (place && place.width) {
            gl.uniform4f(u('lr'), (place.left - box.left) * dpr, (place.top - box.top) * dpr, place.width * dpr, place.height * dpr);
          } else {
            gl.uniform4f(u('lr'), -10, -10, 1, 1);
          }
          gl.uniform1f(u('dpr'), dpr);
          gl.uniform1f(u('blur'), 24 * dpr);
          gl.uniform1f(u('time'), reduceMotion.matches ? 14 : (performance.now() - start) / 1000 + 6);
        } else {
          gl.uniform1f(u('cell'), size * dpr);
          gl.uniform1f(u('refr'), size * 2 * dpr);
          gl.uniform1f(u('blur'), blur * dpr);
          // Smooth, darker glass behind the text so it stays readable
          const box = canvas.getBoundingClientRect();
          // Only the text itself (the text container stretches over the whole middle of the page)
          const parts = [...root.querySelectorAll('.dian-pw__content > *')].map((el) => el.getBoundingClientRect()).filter((r) => r.width && r.height);
          if (parts.length) {
            const left = Math.min(...parts.map((r) => r.left));
            const top = Math.min(...parts.map((r) => r.top));
            const right = Math.max(...parts.map((r) => r.right));
            const bottom = Math.max(...parts.map((r) => r.bottom));
            gl.uniform4f(u('calm'), (left - box.left) * dpr, (top - box.top) * dpr, (right - left) * dpr, (bottom - top) * dpr);
          } else {
            gl.uniform4f(u('calm'), 0, 0, 0, 0);
          }
          gl.uniform1f(u('feather'), 70 * dpr);
        }
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        root.classList.add('dian-pw--gl');
        return true;
      };

      let running = false;
      const loop = () => {
        if (draw() === false || document.hidden) {
          running = false;
          return;
        }
        if (isRain && !reduceMotion.matches) {
          requestAnimationFrame(loop); // the rain moves even between video frames
        } else if ('requestVideoFrameCallback' in video && !video.paused) {
          video.requestVideoFrameCallback(loop);
        } else {
          running = false;
        }
      };
      const kick = () => {
        if (running) {
          draw();
          return;
        }
        running = true;
        loop();
      };
      ['loadeddata', 'seeked', 'play'].forEach((type) => video.addEventListener(type, kick));
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) kick();
      });
      window.addEventListener('resize', () => draw());
      kick();
    };

    // Paper grain (still): gaussian per-pixel noise, one noise pixel per screen pixel.
    const initGrain = () => {
      document.querySelectorAll('[data-dian-pw].dian-pw--paper').forEach((root) => {
        const grain = root.querySelector('.dian-pw__grain');
        const tooth = root.querySelector('.dian-pw__tooth');
        if (!grain || grain.dataset.ready) return;
        grain.dataset.ready = 'true';
        const dpr = window.devicePixelRatio || 1;
        const size = 256;
        const gauss = () => {
          let u = 0;
          let v = 0;
          while (!u) u = Math.random();
          while (!v) v = Math.random();
          return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
        };
        const noise = (spread) => {
          const canvas = document.createElement('canvas');
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          const image = ctx.createImageData(size, size);
          for (let i = 0; i < size * size; i += 1) {
            const g = Math.max(0, Math.min(255, 128 + gauss() * spread));
            image.data[i * 4] = g;
            image.data[i * 4 + 1] = g;
            image.data[i * 4 + 2] = g;
            image.data[i * 4 + 3] = 255;
          }
          ctx.putImageData(image, 0, 0);
          return canvas;
        };
        try {
          const fine = noise(38);
          root.style.setProperty('--pw-grain-img', `url(${fine.toDataURL()})`);
          root.style.setProperty('--pw-grain-size', `${size / dpr}px ${size / dpr}px`);
          // Blur a 3x3 tiling and keep the middle, so the texture tiles without seams.
          const base = noise(60);
          const big = document.createElement('canvas');
          big.width = size * 3;
          big.height = size * 3;
          const bctx = big.getContext('2d');
          bctx.filter = 'blur(1.4px)';
          for (let y = 0; y < 3; y += 1) {
            for (let x = 0; x < 3; x += 1) bctx.drawImage(base, x * size, y * size);
          }
          const soft = document.createElement('canvas');
          soft.width = size;
          soft.height = size;
          soft.getContext('2d').drawImage(big, size, size, size, size, 0, 0, size, size);
          root.style.setProperty('--pw-tooth-img', `url(${soft.toDataURL()})`);

          root.style.setProperty('--pw-tooth-size', `${(size * 1.5) / dpr}px ${(size * 1.5) / dpr}px`);
        } catch (error) {
          return; // keep the SVG grain
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGrain);
    else initGrain();

    const initGlass = () =>
      document.querySelectorAll('[data-dian-pw].dian-pw--textured, [data-dian-pw].dian-pw--rain').forEach(startGlass);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGlass);
    else initGlass();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
